import { render, staticRenderFns } from "./LicensingDetailsGeneralData.vue?vue&type=template&id=1def2b2a&"
import script from "./LicensingDetailsGeneralData.vue?vue&type=script&lang=js&"
export * from "./LicensingDetailsGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports